module.exports = __webpack_public_path__ + "1.4.15-unryo/img/riverbed.dd2598a8.svg";